import api from "@client/content/lib/api";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type HttpApiResponse } from "@client/types/Api";
import { type BlogDetailComments } from "./types";

export default {
  addComment: (
    apiInfo: ModuleApiInfo,
    { postId, ...args }: BlogDetailComments.Api.AddCommentRequest
  ): Promise<HttpApiResponse<BlogDetailComments.Api.AddCommentResponse>> =>
    api.post(apiInfo, `/api/site/v1/modules/blog/posts/${postId}/comments`, args),
  init: (
    apiInfo: ModuleApiInfo,
    { postId, ...args }: BlogDetailComments.Api.InitRequest
  ): Promise<HttpApiResponse<BlogDetailComments.Api.InitResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/blog/posts/${postId}/comments`, args),
  loadMore: (
    apiInfo: ModuleApiInfo,
    { postId, ...args }: BlogDetailComments.Api.LoadMoreRequest
  ): Promise<HttpApiResponse<BlogDetailComments.Api.LoadMoreResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/blog/posts/${postId}/comments/page`, args)
};
